import { render, staticRenderFns } from "./edit-customer.vue?vue&type=template&id=0c196c8c&"
import script from "./edit-customer.vue?vue&type=script&lang=js&"
export * from "./edit-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports